import { PayloadAction } from '@reduxjs/toolkit'
import { TProductFilters } from '../../../models'

const removeBrands = (
  state: TProductFilters[],
  action: PayloadAction<{
    id: number
  }>
) => {
  const selectedFilters = state.find((item) => item.id === action.payload.id)

  if (selectedFilters) {
    delete selectedFilters.filters.brands
  }
}

export default removeBrands
